import type { ValidateResult } from 'react-hook-form'

export const isValidValidatorResult = (result: ValidateResult) => typeof result === 'undefined' || result === true
